import { render, staticRenderFns } from "./RadioStatus.vue?vue&type=template&id=62f07618&scoped=true&lang=pug"
import script from "./RadioStatus.vue?vue&type=script&lang=js"
export * from "./RadioStatus.vue?vue&type=script&lang=js"
import style0 from "./RadioStatus.vue?vue&type=style&index=0&id=62f07618&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f07618",
  null
  
)

export default component.exports